const createInvokeRequest = (request, payload) => ({
  action: {
    ...request.action,
    payload
  },
  providerKey: request.providerKey
});
export default createInvokeRequest;